import React from 'react';

const SportsManagerModal = ({
  show,
  onClose,
  newSport,
  setNewSport,
  handleAddSport,
  sportsLoading,
  sports,
  editingSport,
  editSportValue,
  setEditSportValue,
  handleSaveEditSport,
  onCancelEdit,
  handleEditSport,
  handleRemoveSport,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-xs sm:max-w-md w-full mx-2 sm:mx-4 max-h-96 overflow-y-auto">
        <div className="p-4 sm:p-6">
          <div className="flex justify-between items-center mb-3 sm:mb-4">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900">Manage Sports</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="mb-3 sm:mb-4">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">Add New Sport</label>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                value={newSport}
                onChange={(e) => setNewSport(e.target.value)}
                placeholder="Enter sport name (e.g., Swimming)"
                className="flex-1 border border-gray-300 rounded px-3 py-2 text-xs sm:text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                onKeyPress={(e) => e.key === 'Enter' && handleAddSport()}
              />
              <button
                onClick={handleAddSport}
                disabled={sportsLoading}
                className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-3 sm:px-4 py-2 rounded text-xs sm:text-sm w-full sm:w-auto"
              >
                {sportsLoading ? 'Adding...' : 'Add'}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
              Current Sports ({sports.length})
            </label>
            <div className="space-y-1 sm:space-y-2 max-h-64 overflow-y-auto">
              {sports.map((sport) => (
                <div key={sport._id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  {editingSport === sport._id ? (
                    <div className="flex-1 flex flex-col sm:flex-row gap-2">
                      <input
                        type="text"
                        value={editSportValue}
                        onChange={(e) => setEditSportValue(e.target.value)}
                        className="flex-1 border border-gray-300 rounded px-2 py-1 text-xs sm:text-sm"
                        onKeyPress={(e) => e.key === 'Enter' && handleSaveEditSport()}
                      />
                      <div className="flex gap-1">
                        <button
                          onClick={handleSaveEditSport}
                          disabled={sportsLoading}
                          className="bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white px-2 py-1 rounded text-xs flex-1 sm:flex-none"
                        >
                          {sportsLoading ? 'Saving...' : 'Save'}
                        </button>
                        <button
                          onClick={onCancelEdit}
                          className="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs flex-1 sm:flex-none"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex-1">
                        <div className="font-medium text-xs sm:text-sm">{sport.displayName}</div>
                      </div>
                      <div className="flex gap-1">
                        <button
                          onClick={() => handleEditSport(sport)}
                          className="text-blue-600 hover:text-blue-800 p-1"
                          title="Edit sport"
                        >
                          <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                        </button>
                        <button
                          onClick={() => handleRemoveSport(sport)}
                          disabled={sportsLoading}
                          className="text-red-600 hover:text-red-800 disabled:text-red-400 p-1"
                          title="Remove sport"
                        >
                          <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SportsManagerModal;